/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Weighings_Date_FromInputs */

const vi_my_weighings_date_from = /** @type {(inputs: My_Weighings_Date_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ ngày`)
};

/**

* @param {My_Weighings_Date_FromInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_weighings_date_from = /** @type {((inputs?: My_Weighings_Date_FromInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Weighings_Date_FromInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_weighings_date_from(inputs)
});